import { useNavigate } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useUISettings } from '../context/UISettingsContext';
import { useGlobalLoading } from '../context/GlobalLoadingContext';

export default function Forbidden() {
  const navigate = useNavigate();
  const location = useLocation();
  const { resolvedTheme } = useUISettings();
  const { stopLoading } = useGlobalLoading();
  const isDark = resolvedTheme === 'dark';
  const { buttonLabel, backTarget, subtitle } = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const reason = params.get('reason') || '';
    const rawBack = params.get('back') || '';
    const safeBack = rawBack.startsWith('/results/') ? rawBack : '/assessment';

    if (reason === 'results-access-denied') {
      return {
        buttonLabel: 'Back to results',
        backTarget: safeBack,
        subtitle: 'You do not have access to this results page.',
      };
    }

    return {
      buttonLabel: 'Back to assessment',
      backTarget: '/assessment',
      subtitle: 'You do not have admin access to this area.',
    };
  }, [location.search]);

  useEffect(() => {
    // Ensure no stale loading overlay blocks forbidden actions.
    stopLoading();
  }, [stopLoading]);

  return (
    <div
      className="flex min-h-screen items-center justify-center px-4"
      style={{ background: isDark ? '#0f172a' : '#f8fafc' }}
    >
      <div
        data-testid="permission-denied-banner"
        className="w-full max-w-xl rounded-2xl px-6 py-6 text-center"
        style={
          isDark
            ? {
                border: '1px solid rgba(248, 113, 113, 0.35)',
                background: 'linear-gradient(120deg, rgba(40,10,16,0.95), rgba(30,41,59,0.94))',
                color: '#fecaca',
                boxShadow: '0 20px 60px -24px rgba(239, 68, 68, 0.55)',
              }
            : {
                border: '1px solid rgba(239, 68, 68, 0.2)',
                background: 'linear-gradient(120deg, rgba(255,241,242,0.99), rgba(254,226,226,0.97))',
                color: '#0f172a',
                boxShadow: '0 24px 70px -30px rgba(239, 68, 68, 0.26)',
              }
        }
      >
        <span
          className="mb-2 block text-[10px] font-black uppercase tracking-[0.26em]"
          style={{ color: isDark ? 'rgba(248, 113, 113, 0.95)' : '#b91c1c' }}
        >
          Permission Denied
        </span>
        <p className="mb-4 text-sm font-semibold leading-relaxed">
          {subtitle}
        </p>
        <button
          data-testid="permission-denied-back-btn"
          type="button"
          onClick={() => navigate(backTarget)}
          className="rounded-full bg-indigo-600 px-4 py-2 text-[10px] font-black uppercase tracking-[0.14em] text-white transition-all hover:bg-indigo-500"
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  );
}
